import React from 'react';
import { Col } from 'react-bootstrap';
import { FaFacebook } from 'react-icons/fa';
import styled from 'styled-components';
import './Footer.css';

// TODO: Replace react-bootstrap components with custom components
function FirstColInfo() {
  return (
    <Col xs={{ span: 8, offset: 2 }} sm={{ span: 6, offset: 0 }} md={4} className="widget">
    </Col>
  );
}

function ContactInfo() {
  return (
    <Col xs={{ span: 8, offset: 2 }} sm={{ span: 6, offset: 0 }} md={4} className="widget">
      <WidgetHeader>Contact Us</WidgetHeader>
      <br />
      <p>
        You may contact us <Link href="/contact">here</Link> or call (619) 321-8185
      </p>
      <Icons>
        <a href="https://www.facebook.com/khodamaya/" target="_blank" rel="noopener noreferrer">
          <FaFacebook />
        </a>
      </Icons>
    </Col>
  );
}

function ThirdColInfo() {
  return (
    <Col xs={{ span: 8, offset: 2 }} sm={{ span: 6, offset: 3 }} md={{ span: 4, offset: 0 }} className="widget">
    </Col>
  );
}

function Footer() {
  return (
    <Section>
      <Row>
        <FirstColInfo />
        <ContactInfo />
        <ThirdColInfo />
      </Row>
    </Section>
  );
}

export { Footer };

const Section = styled.div`
  width: 100%;
  background-color: var(--primary-color);

  & p {
    font-size: 15px;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
  }

  & ul {
    font-size: 15px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px 20px;
  margin: 0 auto;

  @media (min-width: 576px)
    max-width: 570px;
  }
  @media (min-width: 768px) {
    max-width: 750px;
  }
  @media (min-width: 992px) {
    max-width: 990px;
  }
  @media (min-width: 1200px) {
    max-width: 1170px;
  }
`;

const WidgetHeader = styled.div`
  font-size: 20px;
  border-bottom: 1px dotted white;
  padding-top: 20px;
  padding-bottom: 10px;
`;

const Link = styled.a`
  color: var(--accent-color);
`;

const Icons = styled.div`
  & svg {
    color: #fff;
    font-size: 3em;
    margin: 0 20px;
    transition: color 0.3s, background-color 0.3s;
  }
`;
